module.exports = __webpack_public_path__ + "static/media/randy-colas.98f13882.jpg";